/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { AlertminerApiConfiguration as __Configuration } from '../alertminer-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DealerInfoDto } from '../models/dealer-info-dto';
@Injectable({
  providedIn: 'root',
})
class DealerSearchClientService extends __BaseService {
  static readonly GETPath = '/api/DealerSearch';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Success
   */
  GETResponse(): __Observable<__StrictHttpResponse<Array<DealerInfoDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DealerSearch`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DealerInfoDto>>;
      })
    );
  }
  /**
   * @return Success
   */
  GET(): __Observable<Array<DealerInfoDto>> {
    return this.GETResponse().pipe(
      __map(_r => _r.body as Array<DealerInfoDto>)
    );
  }
}

module DealerSearchClientService {
}

export { DealerSearchClientService }
